<div class="main-pic">
    <img class="slide" src="{ $sidebar.items[n]["slide"] }" alt="" />
</div>
<style>
    .main-pic {
        width: 100%;
        height: auto;
    }
    .slide { 
        width: 100%;
        height: auto;
        object-fit: cover;
    }
</style>
<script>
    import { sidebar } from '../store.js';
    // import { stores } from '@sapper/app';
    // const { preloading, page, session } = stores();

    export let path ='';
    
    let n = 0;
    for (let i=0; i < $sidebar.items.length; i++) {
        if (path.indexOf($sidebar.items[i]["path"]) >= 0) {
            n = i;
            break;
        }
    }
    
    

</script>